import { create } from 'zustand';

export const useUIStore = create((set) => ({
  pageTitle: null,
  setPageTitle: (title) => set({ pageTitle: title }),
}));




